/**
 * The recipe as a card to make it from: prep across the top, the lines down
 * the left, each step beside the lines in its own column, the garnish last.
 * Static: the same shape for every drink, read top to bottom and left to
 * right.
 */

import type { RecipeCard as Card } from "@baros/core";

interface Props {
  readonly card: Card;
  readonly caption: string;
}

export function RecipeCard({ card, caption }: Props) {
  const P = card.prep.length;
  const N = Math.max(card.lines.length, 1);
  const columns = card.steps.length + (card.garnish ? 1 : 0);
  const endCol = columns + 2;

  if (card.lines.length === 0 && card.steps.length === 0) {
    return <div className="label" style={{ padding: "12px 0" }}>No build on file yet.</div>;
  }

  return (
    <div className="rcard">
      <div className="rcard-grid" style={{ gridTemplateColumns: `minmax(0, 2.4fr) repeat(${columns}, minmax(0, 1fr))` }}>
        {card.prep.map((text, i) => (
          <div key={`p${i}`} className="rcell rcell-pre" style={{ gridColumn: `1 / ${endCol}`, gridRow: `${i + 1} / ${i + 2}` }}>
            {text}
          </div>
        ))}
        {card.lines.map((text, i) => (
          <div key={`l${i}`} className="rcell" style={{ gridColumn: "1 / 2", gridRow: `${P + i + 1} / ${P + i + 2}` }}>
            {text}
          </div>
        ))}
        {card.steps.map((text, i) => (
          <div key={`s${i}`} className="rcell rcell-step" style={{ gridColumn: `${i + 2} / ${i + 3}`, gridRow: `${P + 1} / ${P + N + 1}` }}>
            {text}
          </div>
        ))}
        {card.garnish && (
          <div className="rcell rcell-step" style={{ gridColumn: `${columns + 1} / ${columns + 2}`, gridRow: `${P + 1} / ${P + N + 1}` }}>
            {card.garnish}
          </div>
        )}
      </div>
      <div className="ann" style={{ color: "var(--t2)" }}>{caption}</div>
    </div>
  );
}
